import {Injectable} from '@angular/core';
import {MvsCrudService} from "../../../../core/shared/service/crud/mvs-crud.service";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";
import {CampaignMemberNoteDto} from "../../model/dto/entity/campaign-member-note.dto";

@Injectable({
    providedIn: 'root'
})
export class CampaignMemberNoteService extends MvsCrudService {

    constructor(protected http: HttpClient) {
        super(http, MvsCrudService.baseUrl + '/ct/campaignMemberNotes')
    }

    getObjectIcon(): string {
        return 'fa-solid fa-note-sticky';
    }

    /**
     * Gets all notes for a campaign member.
     */
    getByMemberId(memberId: number, noteType?: string): Observable<CampaignMemberNoteDto[]> {
        let suffix = `/byMember/${memberId}`;
        if (noteType) {
            suffix += `?noteType=${noteType}`;
        }
        return this.getGeneric<CampaignMemberNoteDto[]>(suffix);
    }

    /**
     * Gets all pinned notes for a campaign member.
     */
    getPinnedNotes(memberId: number): Observable<CampaignMemberNoteDto[]> {
        return this.getGeneric<CampaignMemberNoteDto[]>(`/byMember/${memberId}/pinned`);
    }

    /**
     * Searches notes within a campaign member.
     */
    searchNotes(memberId: number, searchTerm: string): Observable<CampaignMemberNoteDto[]> {
        return this.getGeneric<CampaignMemberNoteDto[]>(`/byMember/${memberId}/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    }

    /**
     * Searches notes across all campaign members.
     */
    searchAllNotes(searchTerm: string): Observable<CampaignMemberNoteDto[]> {
        return this.getGeneric<CampaignMemberNoteDto[]>(`/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    }

    /**
     * Gets all member notes for a campaign.
     */
    getByCampaignId(campaignId: number): Observable<CampaignMemberNoteDto[]> {
        return this.getGeneric<CampaignMemberNoteDto[]>(`/byCampaign/${campaignId}`);
    }

    /**
     * Searches member notes within a campaign.
     */
    searchNotesByCampaignId(campaignId: number, searchTerm: string): Observable<CampaignMemberNoteDto[]> {
        return this.getGeneric<CampaignMemberNoteDto[]>(`/byCampaign/${campaignId}/search?searchTerm=${encodeURIComponent(searchTerm)}`);
    }

    /**
     * Toggles the pinned status of a note.
     */
    togglePin(noteId: number): Observable<CampaignMemberNoteDto> {
        return this.postGeneric<CampaignMemberNoteDto>({}, `/${noteId}/togglePin`);
    }

    /**
     * Toggles the private status of a note.
     */
    togglePrivate(noteId: number): Observable<CampaignMemberNoteDto> {
        return this.postGeneric<CampaignMemberNoteDto>({}, `/${noteId}/togglePrivate`);
    }
}
